module.exports = __webpack_public_path__ + "plat/static/img/end.cec09638.png";